export const sidebarContainer = "szonz5v";
export const toggleButton = "t1o0o7pr";

require("./style.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");